import { createSelector } from 'reselect';

import getAreasByCityId from '@core/reducers/areas/selectors/getAreasByCityId';
import getSelectedCity from './getSelectedCity';

const getSelectedCityAreas = createSelector(
  getSelectedCity,
  getAreasByCityId,
  (city, getAreas) => {
    const cityAreas = getAreas(city?.id);
    return cityAreas || [];
  },
);

export default getSelectedCityAreas;
